import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import moment from "moment";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: { label: string; value: string }[];
  month: number;
  year: number;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
  month: moment().month() + 1,
  year: moment().year(),
};

const getListArriveLateSlice = createSlice({
  name: "getListArriveLate",
  initialState,
  reducers: {
    setMonthYearListArriveLate: (
      state,
      action: PayloadAction<{ month: number; year: number }>
    ) => {
      state.month = action.payload.month;
      state.year = action.payload.year;
    },
    getListArriveLateStart: (state, action: PayloadAction<object>) => {
      state.status = ReduxStateType.LOADING;
    },
    getListArriveLateSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getListArriveLateFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    updateListArriveLate: (state, action) => {
      state.data = action.payload;
    },
    resetListArriveLate: () => {
      return { ...initialState };
    },
  },
});

export const {
  setMonthYearListArriveLate,
  getListArriveLateStart,
  getListArriveLateSuccess,
  getListArriveLateFailed,
  resetListArriveLate,
  updateListArriveLate,
} = getListArriveLateSlice.actions;

export default getListArriveLateSlice.reducer;
